import { inject, Injectable } from '@angular/core';

import { BootstrapSandboxService } from '@bootstrap/sandbox/bootstrap.sandbox.service';
import { environment } from '@env/environment';
import { BaseAuthGuard } from '@mediahaven/shared';

@Injectable({ providedIn: 'root' })
export class AuthGuard extends BaseAuthGuard {
    protected override readonly sandbox: BootstrapSandboxService = inject(BootstrapSandboxService);

    constructor() {
        super();
        this.isAuthenticated$ = this.sandbox.isAuthenticated$;
        this.environment = environment;
    }
}
